import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BadgeStyled } from 'features/tariffs/edit/ui/UnitsDiff/UnitsDiff.styles';

interface UnitsDeletedProps {
	units: number;
}

export const UnitsDiff: FC<UnitsDeletedProps> = ({ units }) => {
	const { t } = useTranslation();
	if (units === 0) {
		return null;
	}

	return units < 0 ? (
		<BadgeStyled positive={false}>{t(`Marketplace_Units_Deleted`, { units: Math.abs(units) })}</BadgeStyled>
	) : (
		<BadgeStyled positive>{t(`Marketplace_Units_Added`, { units: Math.abs(units) })}</BadgeStyled>
	);
};
